import { render, staticRenderFns } from "./stationCollect.vue?vue&type=template&id=93fcf876&scoped=true&"
import script from "./stationCollect.vue?vue&type=script&lang=js&"
export * from "./stationCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fcf876",
  null
  
)

export default component.exports